import { Grid, makeStyles } from "@material-ui/core";
import React from "react";
import LeaderboardTable from "./LeaderboardTable";

const useStyles = makeStyles({
  leaderContainer: {
    paddingLeft: 48,
    paddingRight: 48,
    paddingTop: 48,
    paddingBottom: 48,
  },
});

function Leaderboard() {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid item xs={12} className={classes.leaderContainer}>
        <LeaderboardTable />
      </Grid>
    </Grid>
  );
}

export default Leaderboard;
